import { AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component, Input } from '@angular/core';
import { User } from 'app/models';
import { CalendarEventResponse, CalendarEventTypeEnum } from 'app/models/CalendarEvent';
import { HomepageService } from 'app/services/homepage.service';

@Component({
	changeDetection: ChangeDetectionStrategy.OnPush,
	selector: 'sp-future-passes-activities',
	template: `
		<div class="pass-collection future-passes">
			<sp-pass-collection-v2>
				<sp-collection-title>Upcoming This Week</sp-collection-title>
				<ng-container collection-content *ngFor="let pass of homePageService.futurePassesAndActivitiesForStudents">
					<sp-pass-tile-large
						*ngIf="isHallPass(pass)"
						[isStaff]="false"
						[isStudent]="true"
						[studentName]="effectiveUser.display_name"
						[roomName]="pass.hall_pass.destination.title"
						[roomIcon]="pass.hall_pass.icon"
						[startTime]="pass.hall_pass.start_time"
						[endTime]="pass.hall_pass.expiration_time"
						[colorProfile]="pass.hall_pass.color_profile"
						(click)="homePageService.openPassDialog(pass.hall_pass, true, false)"></sp-pass-tile-large>
				</ng-container>
			</sp-pass-collection-v2>
		</div>
	`,
})
export class FuturePassesActivitiesComponent implements AfterViewInit {
	@Input() effectiveUser!: User;

	constructor(public homePageService: HomepageService, private cdRef: ChangeDetectorRef) {}

	ngAfterViewInit() {
		setTimeout(() => this.cdRef.detectChanges());
	}

	isHallPass(event: CalendarEventResponse): boolean {
		return event.type === CalendarEventTypeEnum.HALL_PASS;
	}
}
